import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.success) {
      navigate(res.user?.role === "admin" ? "/admin" : location.state?.from?.pathname || "/account");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="container-lookers py-20 max-w-md mx-auto" data-testid="login-page">
      <h1 className="font-heading font-semibold uppercase text-4xl mb-8 text-zinc-950">
        Log In
      </h1>
      <form onSubmit={onSubmit} className="space-y-4">
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none" data-testid="login-email-input" />
        <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none" data-testid="login-password-input" />
        {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className="w-full bg-teal-600 hover:bg-charcoal text-white font-heading font-bold text-xs uppercase tracking-wide py-3.5 transition-colors disabled:opacity-50" data-testid="login-submit-button">
          {loading ? "Logging in…" : "Log In"}
        </button>
      </form>
      <p className="text-sm text-zinc-500 mt-6">
        New to Lookers? <Link to="/register" className="underline text-teal-700" data-testid="go-to-register-link">Create an account</Link>
      </p>
    </div>
  );
}
